import Relatives from './Relatives';

export default Relatives;
